import HarIdxFrame from "../../components/HarIdxFrame";

export default function MlsSearchPage() {
  return (
    <HarIdxFrame
      eyebrow="HAR · MLS Search"
      title="Search the full Houston MLS"
      description="Browse every active listing in the Houston MLS — powered by HAR.com, curated for you by Gens Realty."
      path="mls/search"
      extraParams="allmls=y&for_sale=1"
      seoPath="/mls-search"
    />
  );
}
